import { FormContextValues } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { medicalCertificateTranslationKeys } from '../../translations';

export type CertificateDetailsValue = string | null;

type CertificateDetailsTextareaProps = Pick<
   FormContextValues<{ certificateDetails: CertificateDetailsValue }>,
   'register'
>;

export const CertificateDetailsTextarea = (props: CertificateDetailsTextareaProps): JSX.Element => {
   const controller = props.register('certificateDetails', {
      required: true,
   });

   return (
      <Textarea
         rows={3}
         maxRows={5}
         focus={false}
         label={medicalCertificateTranslationKeys.form.certificateDetailsTextarea.label}
         controller={controller}
         maxLength={3600}
         placeholder={medicalCertificateTranslationKeys.form.certificateDetailsTextarea.placeholder}
         testId={'certificateDetails'}
      />
   );
};
